"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const auth0_react_1 = require("@auth0/auth0-react");
const react_1 = require("@honeybadger-io/react");
const browser_1 = __importDefault(require("@hyperdx/browser"));
const react_2 = require("react");
const react_toastify_1 = require("react-toastify");
const components_1 = require("components");
const config_1 = require("config");
const AnalyticsContext_1 = require("../../context/AnalyticsContext");
const FeaturesContext_1 = require("../../context/FeaturesContext");
const browserHistory_1 = __importDefault(require("../../services/browserHistory"));
const Routes_1 = __importDefault(require("./Routes"));
function App() {
    // State
    const testEnv = (0, config_1.getTestEnv)();
    const { setAppName } = (0, react_2.useContext)(AnalyticsContext_1.AnalyticsContext);
    const initHoneybadger = () => {
        return react_1.Honeybadger.configure({
            apiKey: process.env.REACT_APP_HONEYBADGER_API_KEY,
            environment: process.env.REACT_APP_BUILD_ENV,
        });
    };
    const honeybadger = initHoneybadger();
    const init = () => {
        // HyperDX
        let checkRegEx = null;
        if (testEnv) {
            checkRegEx = [/api.qa.alphaeontest.com/i];
        }
        else {
            checkRegEx = [/api.alphaeon.com/i];
        }
        if (!testEnv) {
            browser_1.default.init({
                apiKey: config_1.REACT_APP_HYPERDX,
                service: 'merchant-portal',
                tracePropagationTargets: checkRegEx, // Set to link traces from frontend to backend requests
                consoleCapture: true, // Capture console logs (default false)
                advancedNetworkCapture: true, // Capture full HTTP request/response headers and bodies (default false)
            });
        }
        if (setAppName) {
            setAppName('merchant-portal');
        }
        browser_1.default.setGlobalAttributes({
            site_environment: testEnv ? 'DEV' : 'PROD',
            site_portal: 'merchant-portal',
        });
    };
    (0, react_2.useEffect)(() => {
        init();
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(AnalyticsContext_1.AnalyticsProvider, { appName: "merchant-portal", children: (0, jsx_runtime_1.jsx)(FeaturesContext_1.FeaturesProvider, { children: (0, jsx_runtime_1.jsxs)(react_1.HoneybadgerErrorBoundary, { honeybadger: honeybadger, children: [(0, jsx_runtime_1.jsx)(react_toastify_1.ToastContainer, { closeButton: components_1.ToastDismissButton }), (0, jsx_runtime_1.jsxs)(auth0_react_1.Auth0Provider, { audience: config_1.REACT_APP_ALPHAEON_MERCHANT_MUX_API, clientId: config_1.REACT_APP_ALPHAEON_MERCHANT_AUTH0_CLIENTID, domain: config_1.REACT_APP_AUTH0_DOMAIN, redirectUri: (0, config_1.makePath)(config_1.APPLICATION_ROOT_URL, config_1.PATH.MERCHANT_PORTAL), onRedirectCallback: onRedirectCallback, leeway: 3600, children: [testEnv && (0, jsx_runtime_1.jsx)(components_1.TestEnvironmentBanner, { env: testEnv }), (0, jsx_runtime_1.jsx)(Routes_1.default, {}), (0, jsx_runtime_1.jsx)(components_1.TooZoom, {}), (0, jsx_runtime_1.jsx)(components_1.VersionChangeReporter, { redirectURL: config_1.MERCHANT_PORTAL_URL })] })] }) }) }) }));
}
exports.default = App;
const onRedirectCallback = (appState) => {
    // Use the router's history module to replace the url
    browserHistory_1.default.replace(appState?.returnTo || window.location.pathname, appState);
};
